import { useQuery, gql, useMutation } from '@apollo/client';
import {
  GQLQuerySymbol_GetSymbolsBySymbolCollectionArgs,
  GQLPartyType,
  GQLQuerySymbol_GetSymbolsByMerchantArgs,
  GQLQuerySymbol_GetSymbolsByPlatformArgs,
  GQLQuerySymbol_GetSymbolsByProducerArgs,
  GQLSymbolAsset,
  GQLSymbolAssetConnection,
  GQLSymbol,
  GQLMutationSymbol_CreateSymbolArgs,
  GQLMutationSymbol_UpdateSymbolArgs,
  GQLMutationSymbol_ImportSymbolMediaArgs,
  GQLQuerySymbol_GetSymbolsArgs
} from '@jewelutions/core-crm-server-api-client-domain';
import { SYMBOL_ASSET_FIELDS } from './fragments/symbol';
import { OperationsHelper } from './OperationHelper';

export class SymbolOperation {
  symbolAssetArrayFromResponse(data: any): GQLSymbolAsset[] {
    if (data.Symbol_getSymbols !== undefined) {
      return data.Symbol_getSymbols;
    }

    return OperationsHelper.retrievePropertyFromGQLResponse(data, 'symbols');
  }
  createSymbol() {
    const mutation = gql`
      ${SYMBOL_ASSET_FIELDS}
      mutation createSymbol($input: SymbolAssetInput!, $symbolCollectionId: ID!) {
        Symbol_createSymbol(input: $input, symbolCollectionId: $symbolCollectionId) {
          ...SymbolAssetFields
        }
      }
    `;
    return useMutation<GQLSymbolAsset, GQLMutationSymbol_CreateSymbolArgs>(mutation);
  }

  updateSymbol() {
    const mutation = gql`
      ${SYMBOL_ASSET_FIELDS}
      mutation updateSymbol($symbolId: ID!, $input: SymbolAssetInput!) {
        Symbol_updateSymbol(symbolId: $symbolId, input: $input) {
          ...SymbolAssetFields
        }
      }
    `;
    return useMutation<GQLSymbolAsset, GQLMutationSymbol_UpdateSymbolArgs>(mutation);
  }

  importSymbolMedia() {
    const mutation = gql`
      mutation saveSymbolMedia($symbolId: ID!, $file: Upload!) {
        Symbol_importSymbolMedia(symbolId: $symbolId, file: $file)
      }
    `;
    return useMutation<Boolean, GQLMutationSymbol_ImportSymbolMediaArgs>(mutation);
  }

  getSymbolsBySymbolCollection(args: GQLQuerySymbol_GetSymbolsBySymbolCollectionArgs) {
    const query = gql`
      ${SYMBOL_ASSET_FIELDS}
      query getSymbolsByPlatform($symbolCollectionId: ID!, $pageSize: Int = 10) {
        Symbol_getSymbolsBySymbolCollection(symbolCollectionId: $symbolCollectionId, pageSize: $pageSize) {
          symbols {
            ...SymbolAssetFields
          }
        }
      }
    `;
    return useQuery<GQLSymbolAssetConnection, GQLQuerySymbol_GetSymbolsBySymbolCollectionArgs>(query, {
      variables: args
    });
  }

  getSymbolsByPlatform(args: GQLQuerySymbol_GetSymbolsByPlatformArgs) {
    const query = gql`
      ${SYMBOL_ASSET_FIELDS}
      query getSymbolsByPlatform($pageSize: Int = 10) {
        Symbol_getSymbolsByPlatform(pageSize: $pageSize) {
          symbols {
            ...SymbolAssetFields
          }
        }
      }
    `;
    return useQuery<GQLSymbolAssetConnection, GQLQuerySymbol_GetSymbolsByPlatformArgs>(query, {
      variables: args
    });
  }

  getSymbolsByProducer(args: GQLQuerySymbol_GetSymbolsByProducerArgs) {
    const query = gql`
      ${SYMBOL_ASSET_FIELDS}
      query getSymbolsByProducer($producerPartyId: ID!) {
        Symbol_getSymbolsByProducer(producerPartyId: $producerPartyId, pageSize: 10) {
          symbols {
            ...SymbolAssetFields
          }
        }
      }
    `;
    return useQuery<GQLSymbolAssetConnection, GQLQuerySymbol_GetSymbolsByProducerArgs>(query, {
      variables: args
    });
  }

  getSymbolsByMerchant(args: GQLQuerySymbol_GetSymbolsByMerchantArgs) {
    const query = gql`
      ${SYMBOL_ASSET_FIELDS}
      query getSymbolsByMerchant($merchantPartyId: ID!) {
        Symbol_getSymbolsByMerchant(merchantPartyId: $merchantPartyId) {
          cursor
          hasMore
          symbols {
            ...SymbolAssetFields
          }
        }
      }
    `;
    return useQuery<GQLSymbolAssetConnection, GQLQuerySymbol_GetSymbolsByMerchantArgs>(query, {
      variables: args
    });
  }

  getSymbols(args: GQLQuerySymbol_GetSymbolsArgs) {
    const query = gql`
      ${SYMBOL_ASSET_FIELDS}
      query getSymbols($symbolIds: [ID!]!) {
        Symbol_getSymbols(symbolIds: $symbolIds) {
          ...SymbolAssetFields
        }
      }
    `;
    return useQuery<GQLSymbolAsset[], GQLQuerySymbol_GetSymbolsArgs>(query, {
      variables: args
    });
  }
}
